import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import App from './AppProducts';

export default class Root extends Component {
  render() {
    const { store, history, catId, subCatId, brandId, titleOverride, filter, prefer, isNonOemFirst } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App catId={catId}
               subCatId={subCatId}
               brandId={brandId}
               titleOverride={titleOverride}
               filter={filter}
               prefer={prefer}
               isNonOemFirst={isNonOemFirst}
               isFetching="true"
          />
        </ConnectedRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  catId: PropTypes.number,
  subCatId: PropTypes.number,
  brandId: PropTypes.number,
  titleOverride: PropTypes.string,
  filter: PropTypes.string,
  prefer: PropTypes.string,
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
